import { render, staticRenderFns } from "./pos-index.vue?vue&type=template&id=ca25b816"
import script from "./pos-index.vue?vue&type=script&lang=js"
export * from "./pos-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports